import { UserEditRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const editRoute = {
  path: 'edit',
  element: <UserEditRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Edit</span>,
  }),
};